import { COMMON_AXISLABEL_FORMATTER } from './base';
export var SZ_THEME = {
  // 背景色
  DM_BACKGROUND_COLOR: '#DFEFFF',
  // 主题色
  SZ_COLOR: ['#175EDE', '#19C72B', '#F8B40C', '#DE1717', '#7D17DE', '#17C8DE', '#C85F1D', '#C81789', '#2D17DE', '#25D090', '#F1891C', '#F0E611'],
  // 图例
  SZ_LEGEND: {
    type: 'plain',
    icon: 'circle',
    bottom: 15,
    itemWidth: 9,
    itemHeight: 9,
    itemGap: 20,
    padding: 0,
    itemStyle: {
      opacity: 1
    },
    textStyle: {
      color: 'rgba(0, 0, 0, 0.7)',
      fontSize: 12,
      lineHeight: 18,
      padding: 0,
      fontFamily: 'Microsoft YaHei'
    }
  },
  // tooltip
  SZ_TOOLTIP: {
    show: true,
    confine: true,
    trigger: 'axis',
    borderRadius: 4,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderWidth: 0,
    textStyle: {
      color: 'rgba(0, 0, 0, 0.65)'
    }
  },
  // 轴线样式
  SZ_AXISLINE: {
    show: true,
    lineStyle: {
      type: 'solid',
      color: '#C6CDD3'
    }
  },
  // 轴文本样式
  SZ_AXISLABEL: {
    show: true,
    margin: 12,
    color: 'rgba(0, 0, 0, 0.4)',
    formatter: COMMON_AXISLABEL_FORMATTER
  },
  // 参考线样式
  SZ_SPLITLINE: {
    lineStyle: {
      type: 'dashed',
      color: '#E3E6E9'
    }
  },
  // 指示线样式
  SZ_AXISPOINTER: {
    type: 'line',
    lineStyle: {
      type: 'solid',
      color: 'rgba(0, 0, 0, 0.2)'
    },
    z: 0
  },
  // 标示线
  SZ_MARKLINE: {
    lineStyle: {
      width: 1
    },
    emphasis: {
      lineStyle: {
        width: 1
      }
    },
    symbol: 'none',
    label: {
      color: 'inherit',
      padding: [0, 8],
      height: 22,
      borderRadius: 4,
      fontSize: 10,
      fontWeight: 'bold',
      distance: 0
    }
  },
  // 标注
  SZ_MARKPOINT: {
    symbol: 'pin',
    symbolOffset: [0, -7],
    label: {
      color: 'rgba(255, 255, 255, 1)',
      textBorderWidth: 2
    }
  }
};